// Body load opacity
$(window).on("load",(function(){ 
   $("body").animate({opacity:1},700);   
     
}));

// load fadein animation
$(window).on("load",(function(){ 
   $("#filters-drop-down").animate({opacity:1},200);
  $('.collection-list li:nth-child(1) .fadein').addClass("visible");
  $('.collection-list li:nth-child(2) .fadein').addClass("visible");  
  $('.collection-list li:nth-child(3) .fadein').addClass("visible");
  $('.collection-list li:nth-child(4) .fadein').addClass("visible");
  $('.template-index .slideshow-section .fadein').addClass("visible");
  $('#search_grid li:nth-child(1) .fadein').addClass("visible");
  $('#search_grid li:nth-child(2) .fadein').addClass("visible");
  $('#search_grid li:nth-child(3) .fadein').addClass("visible");
  $('#search_grid li:nth-child(4) .fadein').addClass("visible");
  if ($(window).width() < 767) {
  $('.tab-collection-section, .tab-collection-section .fadein').addClass("visible");
  }

  
   $('.onload').addClass("visible");
  $('#stockist_body  #MainContent .image-with-text-section:nth-child(2) .fadein').addClass("visible");
  }));


// Tab clooection slider section
$('.tablink1').mouseover(function() {
    $('.tab_box_1').addClass('active');
    $('.tab_box_2').removeClass('active');
    $('.tab_box_3').removeClass('active');
});
$('.tablink2').mouseover(function() {
    $('.tab_box_1').removeClass('active');
    $('.tab_box_2').addClass('active');
    $('.tab_box_3').removeClass('active');
});
$('.tablink3').mouseover(function() {
    $('.tab_box_1').removeClass('active');
    $('.tab_box_2').removeClass('active');
    $('.tab_box_3').addClass('active');
});

if ($(window).width() < 767) {
$(".tab-collection-link a").attr("href", "javascript:void(0)");
}


// menu open black overly
$('nav li:nth-child(1) > div button').on('click', function() {
  $('.drop-over').toggleClass('active');
  $('.drop-over2').removeClass('active');
  $('header').toggleClass('bg_white');
  $('header').removeClass('bg_white2');
      $('header').removeClass('bg_white3');
  $('body').addClass('model_open');
    $('.search-over').removeClass('active');
});
$('nav li:nth-child(2) > div button').on('click', function() {
    $('.drop-over2').toggleClass('active');
   $('.drop-over').removeClass('active');
  $('header').removeClass('bg_white');
  $('header').toggleClass('bg_white2');
      $('header').removeClass('bg_white3');
   $('body').addClass('model_open');
    $('.search-over').removeClass('active');
});
$('.drop-over, .drop-over2').on('click', function() {
    $('.drop-over2').removeClass('active');
    $('.drop-over').removeClass('active');
    $('header').removeClass('bg_white');
    $('header').removeClass('bg_white2');
    $('header').removeClass('bg_white3');
    $('body').removeClass('model_open');
  
});

// Search open black overly
$('a[x-ref="searchToggle"]').on('click', function() {
    $('.search-over').toggleClass('active');
    $('body').toggleClass('model_open');
    $('header').removeClass('bg_white');
    $('header').removeClass('bg_white2');
    $('header').toggleClass('bg_white3');
    $('.drop-over2').removeClass('active');
    $('.drop-over').removeClass('active');
});
$('.search-over, #search-logo_center_menu_left-desktop + button').on('click', function() {
    $('.search-over').removeClass('active');
    $('body').removeClass('model_open');  
  $('.drop-over2').removeClass('active');
    $('.drop-over').removeClass('active');
      $('header').removeClass('bg_white');
    $('header').removeClass('bg_white2');
    $('header').removeClass('bg_white3');
});

// PLP filter open body scroll hide
$('#filter-drop-down-toggle').on('click', function() {
   $('body').toggleClass('hide_scroll');
});
$('#close_filter').on('click', function() {
   $('body').removeClass('hide_scroll');
});




// fade in grid items  ==================================
  $(document).on("scroll", function () {
    var pageTop = $(document).scrollTop()
    var pageBottom = pageTop + $(window).height()
    var tags = $(".fadein")

    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i]

      if ($(tag).offset().top < pageBottom) {
        $(tag).addClass("visible")
      } else {
        $(tag).removeClass("visible")
      }
    }
  })



// Footer mobile menu
$('body').on('click', '.footer_list h2', function(e) {
    $('footer .grid .break-word').find('ul').stop().slideUp('fast');
    $(this).closest('.break-word').find('ul').stop().slideToggle('fast');

$('.footer_list h2').not(this).removeClass('active');
$(this).toggleClass('active');
  
});


$(document).ready(function(){	
  $('body').on('click', '.sound_off', function(e) {
    if( $(".html-video-wrapper video").prop('muted') ) {
    
          $(".html-video-wrapper video").prop('muted', false);	
		  $(this).removeClass('off');  		  	  
    } else {
	  $(".html-video-wrapper video").prop('muted', true);	
	  $(this).addClass('off');  		
    }
  });


  $('#mc-form').ajaxChimp({
    url: '//shopauroro.us20.list-manage.com/subscribe/post?u=6a2f1095352a113ac8e05887d&amp;id=42fc53fd7d&amp;f_id=009503eef0'
});



  $('body').on('click', '.stop_vid', function(e) {
      var mediaVideo = $(".html-video-wrapper video").get(0);
      if (mediaVideo.paused) {
          mediaVideo.play();
        $(this).removeClass('play'); 
      } else {
          mediaVideo.pause();
        $(this).addClass('play'); 
     }
   });

  $('.copylink_accessibility').attr('href', 'javascript:void(0)');  	

$('body').on('click', '.copylink_accessibility', function(e) {
  $('#accessiblyAppDialogButton').trigger('click');  	
   });
  
   });


var inputcolors = ['#e0ed93','#0c9700','#ff7a00','#ff4d00','#4064e2'];

  $('#mc-email').focus(function() {
    var nputrand = inputcolors[Math.floor(Math.random() * inputcolors.length)];
    $(this).css('background-color', nputrand);
 }).blur(function(){
   $(this).css('background-color', '');
    });


